import request from '@/config';
import { useAppStoreWithOut } from '@/store/app';

enum Apis {
    ViewRecordList = `/api/contract/viewRecordList`,

}

export const ViewRecordList = (searchIpt?: any): Promise<IResponse> => request.post({ url: Apis.ViewRecordList, data: searchIpt });
